import React from 'react';
import { Typography } from 'fronton-react';
import { Section } from 'common/components';
import { lowerBoundsBreakpoints } from 'common/styles/breakpoints';
import {
  header,
  headerMedia,
  headerTitle,
} from './header-styles';

type TProps = {
  title: string;
  video: {
    videoSrc: string;
    videoSrcM?: string;
    previewImg: string;
  };
}

export const Header: React.FC<TProps> = ({ title, video }) => (
  <Section className={header}>
    <Typography className={headerTitle} variant="h1" size="extra">{title}</Typography>
    <video
      autoPlay
      className={headerMedia}
      height="100%"
      width="100%"
      loop
      muted
      poster={video.previewImg}
    >
      {video.videoSrcM ? (
        <>
          <source src={video.videoSrc} type="video/mp4" media={lowerBoundsBreakpoints['--from-tablet']} />
          <source src={video.videoSrcM} type="video/mp4" />
        </>
      ) : (
        <source src={video.videoSrc} type="video/mp4" />
      )}
    </video>
  </Section>
);
